import React, { useState, useEffect } from 'react';
import QueueService from './QueueService';
import './BusinessSettings.css';

const GoogleGIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" style={{ verticalAlign: 'middle', marginRight: '6px' }}>
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
        <path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.62z" />
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" />
    </svg>
);

const InstagramIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" style={{ verticalAlign: 'middle', marginRight: '6px' }}>
        <radialGradient id="igGrad" cx="30%" cy="107%" r="130%">
            <stop offset="0%" stopColor="#fdf497" />
            <stop offset="5%" stopColor="#fdf497" />
            <stop offset="45%" stopColor="#fd5949" />
            <stop offset="60%" stopColor="#d6249f" />
            <stop offset="90%" stopColor="#285AEB" />
        </radialGradient>
        <rect x="2" y="2" width="20" height="20" rx="5" fill="url(#igGrad)" />
        <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm5.5-8.8c-.66 0-1.2.54-1.2 1.2s.54 1.2 1.2 1.2 1.2-.54 1.2-1.2-.54-1.2-1.2-1.2z" fill="#fff" />
    </svg>
);

const WhatsAppIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" style={{ verticalAlign: 'middle', marginRight: '6px' }}>
        <path fill="#25D366" d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984 0 1.763.459 3.486 1.332 5.004L2 22l5.14-1.347a9.96 9.96 0 0 0 4.869 1.269h.004c5.507 0 9.99-4.478 9.99-9.986 0-2.668-1.039-5.176-2.926-7.062A9.923 9.923 0 0 0 12.012 2z" />
        <path fill="#FFF" d="M17.51 14.375c-.302-.152-1.786-.882-2.063-.983-.277-.101-.479-.152-.68.152-.202.303-.782.983-.959 1.185-.177.202-.354.227-.656.076-.302-.152-1.276-.47-2.43-1.499-.899-.802-1.506-1.792-1.683-2.094-.177-.302-.019-.466.132-.616.136-.135.302-.354.454-.53.151-.177.202-.303.303-.505.101-.202.05-.379-.025-.53-.076-.152-.68-1.64-.932-2.246-.245-.589-.495-.51-.68-.519l-.58-.009c-.202 0-.53.076-.807.379-.277.303-1.06 1.035-1.06 2.525s1.085 2.929 1.236 3.131c.152.202 2.135 3.26 5.174 4.572.723.312 1.288.499 1.728.638.726.231 1.387.198 1.91.12.583-.087 1.786-.731 2.038-1.438.252-.706.252-1.312.177-1.438-.075-.126-.277-.202-.579-.354z" />
    </svg>
);

const BusinessSettings = ({ token, business_id }) => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [activeTab, setActiveTab] = useState('general');
    const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

    // Unified state for initial load comparisons and revert support
    const [initialData, setInitialData] = useState(null);
    const [formData, setFormData] = useState({
        business_name: '',
        menu_url: '',
        ad_creative: '',
        opening_hours: '',
        closing_hours: '',
        auto_approve_reservations: false,
        swiggy_res_id: '',
        swiggy_access_token: '',
        zomato_res_id: '',
        easydiner_res_id: '',
        easydiner_access_token: '',
        manager_phone_numbers: [],
        manager_phone_number: '',
        gbp: {
            location_id: '',
            booking_url: null,
            auth_override: {
                account_id: null,
                refresh_token: null,
                connected_email: '',
                connection_status: 'HEALTHY'
            },
            review_overrides: {
                is_enabled: false,
                auto_reply_delay_seconds: 60,
                negative_star_threshold: 3,
                header: null,
                footer: null,
                positive_config: {
                    mode: 'AUTO_AI',
                    templates: [],
                    ai_prompt: ''
                },
                negative_config: {
                    mode: 'AUTO_AI',
                    templates: [],
                    ai_prompt: ''
                }
            }
        },
        brand_id: null,
        brand: null,
        instagram: null
    });

    const [tempPhoneNumber, setTempPhoneNumber] = useState('');
    const [showEditLocationId, setShowEditLocationId] = useState(false);

    const apiUrl = process.env.REACT_APP_API_URL || 'https://api.staging.waitwhiz.in';

    // Toast alert helper
    const showToast = (message, type = 'success') => {
        setToast({ show: true, message, type });
        setTimeout(() => {
            setToast({ show: false, message: '', type: 'success' });
        }, 4000);
    };

    // Load business info
    const fetchBusinessInfo = async () => {
        try {
            setLoading(true);
            const response = await QueueService.GetBusinessInfo(business_id);
            if (response) {
                // Pre-fill default nested config values if missing in API response
                const gbp = {
                    ...(response.business_metadata?.gbp || {}),
                    is_enabled: response.business_metadata?.gbp?.is_enabled ?? (!!response.business_metadata?.gbp?.location_id),
                    location_id: response.business_metadata?.gbp?.location_id || '',
                    location_name: response.business_metadata?.gbp?.location_name || '',
                    booking_url: response.business_metadata?.gbp?.booking_url || null,
                    auth_override: {
                        ...(response.business_metadata?.gbp?.auth_override || {}),
                        account_id: response.business_metadata?.gbp?.auth_override?.account_id || null,
                        refresh_token: response.business_metadata?.gbp?.auth_override?.refresh_token || null,
                        connected_email: response.business_metadata?.gbp?.auth_override?.connected_email || '',
                        connection_status: response.business_metadata?.gbp?.auth_override?.connection_status || 'HEALTHY'
                    },
                    review_overrides: {
                        ...(response.business_metadata?.gbp?.review_overrides || {}),
                        is_enabled: response.business_metadata?.gbp?.review_overrides?.is_enabled ?? false,
                        auto_reply_delay_seconds: response.business_metadata?.gbp?.review_overrides?.auto_reply_delay_seconds || 60,
                        negative_star_threshold: response.business_metadata?.gbp?.review_overrides?.negative_star_threshold || 3,
                        header: response.business_metadata?.gbp?.review_overrides?.header ?? null,
                        footer: response.business_metadata?.gbp?.review_overrides?.footer ?? null,
                        positive_config: {
                            ...(response.business_metadata?.gbp?.review_overrides?.positive_config || {}),
                            mode: response.business_metadata?.gbp?.review_overrides?.positive_config?.mode || 'AUTO_AI',
                            templates: response.business_metadata?.gbp?.review_overrides?.positive_config?.templates || [],
                            ai_prompt: response.business_metadata?.gbp?.review_overrides?.positive_config?.ai_prompt || ''
                        },
                        negative_config: {
                            ...(response.business_metadata?.gbp?.review_overrides?.negative_config || {}),
                            mode: response.business_metadata?.gbp?.review_overrides?.negative_config?.mode || 'AUTO_AI',
                            templates: response.business_metadata?.gbp?.review_overrides?.negative_config?.templates || [],
                            ai_prompt: response.business_metadata?.gbp?.review_overrides?.negative_config?.ai_prompt || ''
                        }
                    }
                };

                const mappedData = {
                    business_name: response.business_name || '',
                    menu_url: response.business_metadata?.menu_url || '',
                    ad_creative: response.business_metadata?.ad_creative || '',
                    opening_hours: response.business_metadata?.opening_hours || '',
                    closing_hours: response.business_metadata?.closing_hours || '',
                    auto_approve_reservations: response.business_metadata?.auto_approve_reservations ?? false,
                    swiggy_res_id: response.business_metadata?.swiggy_res_id || '',
                    swiggy_access_token: response.business_metadata?.swiggy_access_token || '',
                    zomato_res_id: response.business_metadata?.zomato_res_id || '',
                    easydiner_res_id: response.business_metadata?.easydiner_res_id || '',
                    easydiner_access_token: response.business_metadata?.easydiner_access_token || '',
                    manager_phone_numbers: response.business_metadata?.manager_phone_numbers || [],
                    manager_phone_number: response.business_metadata?.manager_phone_number || '',
                    gbp: gbp,
                    insta_to_gmb_active: response.business_metadata?.insta_to_gmb_active ?? response.business_metadata?.insta_to_gmb?.is_active ?? false,
                    insta_to_gmb_cta_type: response.business_metadata?.insta_to_gmb_cta_type || response.business_metadata?.insta_to_gmb?.cta_type || 'LEARN_MORE',
                    insta_to_gmb_cta_url: response.business_metadata?.insta_to_gmb_cta_url || response.business_metadata?.insta_to_gmb?.cta_url || '',
                    insta_to_gmb_ai_prompt: response.business_metadata?.insta_to_gmb_ai_prompt || response.business_metadata?.insta_to_gmb?.ai_prompt || '',
                    brand_id: response.brand_id || null,
                    brand: response.brand || null,
                    instagram: response.instagram || null
                };

                setFormData(mappedData);
                setInitialData(JSON.parse(JSON.stringify(mappedData))); // deep copy
            }
        } catch (error) {
            console.error('Error fetching business info:', error);
            showToast('Failed to load business settings.', 'danger');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (business_id) {
            fetchBusinessInfo();
        }
    }, [business_id, token]);

    // Secure Window OAuth success listener & cleanup
    useEffect(() => {
        const handleOAuthMessage = (event) => {
            const apiOrigin = new URL(apiUrl).origin;
            const currentOrigin = window.location.origin;

            // Secure origin verification
            if (event.origin !== apiOrigin && event.origin !== currentOrigin) {
                return;
            }

            if (event.data && event.data.type === 'OAUTH_SUCCESS') {
                const { provider } = event.data;
                showToast(`${provider === 'whatsapp' ? 'WhatsApp' : 'Instagram'} connected successfully!`, 'success');
                // Refresh status
                fetchBusinessInfo();
            } else if (event.data && event.data.type === 'GBP_OAUTH_SUCCESS') {
                showToast('Google Business Profile connected and mapped successfully!', 'success');
                fetchBusinessInfo();
            }
        };

        window.addEventListener('message', handleOAuthMessage);
        return () => {
            window.removeEventListener('message', handleOAuthMessage);
        };
    }, [apiUrl]);

    // Form dirtiness calculation
    const isDirty = () => {
        if (!initialData) return false;

        const currentEditable = {
            business_name: formData.business_name,
            menu_url: formData.menu_url,
            ad_creative: formData.ad_creative,
            opening_hours: formData.opening_hours,
            closing_hours: formData.closing_hours,
            auto_approve_reservations: formData.auto_approve_reservations,
            swiggy_res_id: formData.swiggy_res_id,
            swiggy_access_token: formData.swiggy_access_token,
            easydiner_res_id: formData.easydiner_res_id,
            easydiner_access_token: formData.easydiner_access_token,
            manager_phone_numbers: formData.manager_phone_numbers,
            gbp: formData.gbp,
            insta_to_gmb_active: formData.insta_to_gmb_active,
            insta_to_gmb_cta_type: formData.insta_to_gmb_cta_type,
            insta_to_gmb_cta_url: formData.insta_to_gmb_cta_url,
            insta_to_gmb_ai_prompt: formData.insta_to_gmb_ai_prompt,
            brand_metadata: formData.brand?.brand_metadata
        };

        const initialEditable = {
            business_name: initialData.business_name,
            menu_url: initialData.menu_url,
            ad_creative: initialData.ad_creative,
            opening_hours: initialData.opening_hours,
            closing_hours: initialData.closing_hours,
            auto_approve_reservations: initialData.auto_approve_reservations,
            swiggy_res_id: initialData.swiggy_res_id,
            swiggy_access_token: initialData.swiggy_access_token,
            easydiner_res_id: initialData.easydiner_res_id,
            easydiner_access_token: initialData.easydiner_access_token,
            manager_phone_numbers: initialData.manager_phone_numbers,
            gbp: initialData.gbp,
            insta_to_gmb_active: initialData.insta_to_gmb_active,
            insta_to_gmb_cta_type: initialData.insta_to_gmb_cta_type,
            insta_to_gmb_cta_url: initialData.insta_to_gmb_cta_url,
            insta_to_gmb_ai_prompt: initialData.insta_to_gmb_ai_prompt,
            brand_metadata: initialData.brand?.brand_metadata
        };

        return JSON.stringify(currentEditable) !== JSON.stringify(initialEditable);
    };

    const [enableWhatsappCoexistence, setEnableWhatsappCoexistence] = useState(false);

    // OAuth Connect Popup Initiator
    const handleConnect = async (provider) => {
        try {
            const brandId = formData.brand?.id || formData.brand_id;
            if (!brandId) {
                showToast('Brand ID not found. Cannot launch connection flow.', 'danger');
                return;
            }

            let linkUrl = `${apiUrl}/fb/generate_${provider === 'whatsapp' ? 'whatsapp' : 'instagram'}_link?brand_id=${brandId}`;
            if (provider === 'whatsapp' && enableWhatsappCoexistence) {
                const extras = JSON.stringify({ featureType: "whatsapp_business_app_onboarding", sessionInfoVersion: "3" });
                linkUrl += `&extras=${encodeURIComponent(extras)}`;
            }

            const response = await fetch(linkUrl, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) {
                throw new Error(`Failed to retrieve Meta connection URL: ${response.statusText}`);
            }
            const resJson = await response.json();
            const url = resJson.data?.url;
            if (!url) {
                throw new Error('Endpoint returned empty connection URL inside data.');
            }

            // Popup sizing & positioning
            const popupWidth = 600;
            const popupHeight = 700;
            const left = window.screenX + (window.outerWidth - popupWidth) / 2;
            const top = window.screenY + (window.outerHeight - popupHeight) / 2;

            const popup = window.open(
                url,
                'MetaOnboardingPopup',
                `width=${popupWidth},height=${popupHeight},left=${left},top=${top},status=no,resizable=yes`
            );

            if (!popup) {
                showToast('Popup blocker active. Please enable popups to connect channel.', 'warning');
            }
        } catch (error) {
            console.error(`Meta oauth initialization error (${provider}):`, error);
            showToast(error.message || 'Error launching connection flow.', 'danger');
        }
    };

    // Google Business Profile OAuth Connect Initiator
    const handleConnectGbp = async () => {
        try {
            const brandId = formData.brand?.id || formData.brand_id;
            if (!brandId) {
                showToast('Brand ID not found. Cannot launch Google connection flow.', 'danger');
                return;
            }

            const linkUrl = `${apiUrl}/business/gbp/auth-url?brand_id=${brandId}`;
            const response = await fetch(linkUrl, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) {
                throw new Error(`Failed to retrieve Google Auth URL: ${response.statusText}`);
            }
            const resJson = await response.json();
            const url = resJson.data?.url || resJson.url;
            if (!url) {
                throw new Error('Endpoint returned empty authorization URL.');
            }

            const popupWidth = 650;
            const popupHeight = 750;
            const left = window.screenX + (window.outerWidth - popupWidth) / 2;
            const top = window.screenY + (window.outerHeight - popupHeight) / 2;

            const popup = window.open(
                url,
                'GoogleGBPAuthPopup',
                `width=${popupWidth},height=${popupHeight},left=${left},top=${top},status=no,resizable=yes`
            );

            if (!popup) {
                showToast('Popup blocker active. Please allow popups to connect Google account.', 'warning');
            }
        } catch (error) {
            console.error('Google GBP oauth initialization error:', error);
            showToast(error.message || 'Error launching Google connection flow.', 'danger');
        }
    };

    // Input handlers
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleGbpChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            gbp: {
                ...prev.gbp,
                [field]: value
            }
        }));
    };

    const handleGbpReviewOverrideChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            gbp: {
                ...prev.gbp,
                review_overrides: {
                    ...prev.gbp.review_overrides,
                    [field]: value
                }
            }
        }));
    };

    const handleGbpConfigModeChange = (type, mode) => {
        setFormData(prev => ({
            ...prev,
            gbp: {
                ...prev.gbp,
                review_overrides: {
                    ...prev.gbp.review_overrides,
                    [type]: {
                        ...prev.gbp.review_overrides[type],
                        mode
                    }
                }
            }
        }));
    };

    const handleGbpConfigPromptChange = (type, ai_prompt) => {
        setFormData(prev => ({
            ...prev,
            gbp: {
                ...prev.gbp,
                review_overrides: {
                    ...prev.gbp.review_overrides,
                    [type]: {
                        ...prev.gbp.review_overrides[type],
                        ai_prompt
                    }
                }
            }
        }));
    };

    const handleAddTemplate = (type) => {
        setFormData(prev => {
            const templates = [...(prev.gbp.review_overrides[type]?.templates || [])];
            templates.push('');
            return {
                ...prev,
                gbp: {
                    ...prev.gbp,
                    review_overrides: {
                        ...prev.gbp.review_overrides,
                        [type]: {
                            ...prev.gbp.review_overrides[type],
                            templates
                        }
                    }
                }
            };
        });
    };

    const handleTemplateValueChange = (type, index, value) => {
        setFormData(prev => {
            const templates = [...(prev.gbp.review_overrides[type]?.templates || [])];
            templates[index] = value;
            return {
                ...prev,
                gbp: {
                    ...prev.gbp,
                    review_overrides: {
                        ...prev.gbp.review_overrides,
                        [type]: {
                            ...prev.gbp.review_overrides[type],
                            templates
                        }
                    }
                }
            };
        });
    };

    const handleRemoveTemplate = (type, index) => {
        setFormData(prev => {
            const templates = (prev.gbp.review_overrides[type]?.templates || []).filter((_, i) => i !== index);
            return {
                ...prev,
                gbp: {
                    ...prev.gbp,
                    review_overrides: {
                        ...prev.gbp.review_overrides,
                        [type]: {
                            ...prev.gbp.review_overrides[type],
                            templates
                        }
                    }
                }
            };
        });
    };

    // Instagram to GMB auto-post metadata change
    const handleInstaToGmbChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Alert manager phone numbers
    const handleAddPhoneNumber = (e) => {
        e.preventDefault();
        const trimmed = tempPhoneNumber.trim();
        if (!trimmed) return;

        // basic regex validation
        if (!/^\d{10,15}$/.test(trimmed)) {
            showToast('Please enter a valid numeric phone number (10 to 15 digits).', 'warning');
            return;
        }

        if (formData.manager_phone_numbers.includes(trimmed)) {
            showToast('Phone number is already in the alert manager list.', 'warning');
            return;
        }

        setFormData(prev => ({
            ...prev,
            manager_phone_numbers: [...prev.manager_phone_numbers, trimmed]
        }));
        setTempPhoneNumber('');
    };

    const handleRemovePhoneNumber = (num) => {
        setFormData(prev => ({
            ...prev,
            manager_phone_numbers: prev.manager_phone_numbers.filter(item => item !== num)
        }));
    };

    // Discard local state edits
    const handleDiscard = () => {
        if (initialData) {
            setFormData(JSON.parse(JSON.stringify(initialData)));
            showToast('Unsaved changes discarded.', 'info');
        }
    };

    // Global Save Handler
    const handleSave = async () => {
        setSaving(true);
        try {
            // 1. Prepare business update details
            const metadataPayload = {
                menu_url: formData.menu_url,
                ad_creative: formData.ad_creative,
                opening_hours: formData.opening_hours,
                closing_hours: formData.closing_hours,
                auto_approve_reservations: formData.auto_approve_reservations ?? false,
                swiggy_res_id: formData.swiggy_res_id,
                swiggy_access_token: formData.swiggy_access_token,
                easydiner_res_id: formData.easydiner_res_id,
                easydiner_access_token: formData.easydiner_access_token,
                manager_phone_numbers: formData.manager_phone_numbers,
                gbp: formData.gbp,
                insta_to_gmb_active: formData.insta_to_gmb_active ?? false,
                insta_to_gmb_cta_type: formData.insta_to_gmb_cta_type || 'LEARN_MORE',
                insta_to_gmb_cta_url: formData.insta_to_gmb_cta_url || '',
                insta_to_gmb_ai_prompt: formData.insta_to_gmb_ai_prompt || '',
                insta_to_gmb: {
                    is_active: formData.insta_to_gmb_active ?? false,
                    cta_type: formData.insta_to_gmb_cta_type || 'LEARN_MORE',
                    cta_url: formData.insta_to_gmb_cta_url || '',
                    ai_prompt: formData.insta_to_gmb_ai_prompt || ''
                },
                // Preserve fields not editable by user but present in initial response
                zomato_res_id: initialData?.zomato_res_id || formData.zomato_res_id || null,
                manager_phone_number: initialData?.manager_phone_number || formData.manager_phone_number || null
            };

            // Save business metadata + business name
            await QueueService.UpdateBusinessInfo(metadataPayload, business_id, token, formData.business_name);

            // 2. Prepare and save brand updates (if available)
            if (formData.brand) {
                const brandPayload = {
                    id: formData.brand.id,
                    name: formData.brand.name,
                    status: formData.brand.status,
                    whatsapp_phone_number: formData.brand.whatsapp_phone_number,
                    whatsapp_phone_number_id: formData.brand.whatsapp_phone_number_id,
                    whatsapp_business_account_id: formData.brand.whatsapp_business_account_id,
                    brand_metadata: formData.brand.brand_metadata
                };

                const brandResponse = await fetch(`${apiUrl}/business/brand_create_or_update`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Referer': apiUrl,
                    },
                    body: JSON.stringify(brandPayload)
                });

                if (!brandResponse.ok) {
                    throw new Error(`Failed to save brand settings: ${brandResponse.statusText}`);
                }
            }

            showToast('All business settings updated successfully!', 'success');
            // Refresh initial references
            setInitialData(JSON.parse(JSON.stringify(formData)));
        } catch (error) {
            console.error('Error saving configurations:', error);
            showToast(error.message || 'Failed to update configurations.', 'danger');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className="bs-settings-container" style={{ textAlign: 'center', padding: '5rem 0' }}>
                <div style={{ fontSize: '1.25rem', fontWeight: 600, color: 'var(--bs-gray-text)' }}>Loading business configurations...</div>
            </div>
        );
    }

    // Helper checks
    const isInstagramConnected = !!(formData.instagram && formData.instagram.is_connected);
    const isWhatsappConnected = !!(formData.whatsapp_phone_number_id || formData.brand?.whatsapp_phone_number_id);

    return (
        <div className="bs-settings-container">
            {/* Toast Notifications */}
            {toast.show && (
                <div className={`bs-toast bs-toast-${toast.type}`}>
                    <div className="bs-toast-message">{toast.message}</div>
                </div>
            )}

            {/* Header Card */}
            <div className="bs-header-card">
                <div className="bs-header-info">
                    <h1>{formData.business_name || 'Business Settings'}</h1>
                    <p>Manage basic information, channel integrations, and alert managers.</p>
                </div>
                <div className="bs-header-actions">
                    <button
                        type="button"
                        className="bs-btn bs-btn-primary"
                        onClick={handleSave}
                        disabled={saving}
                    >
                        {saving ? 'Saving...' : 'Save Settings'}
                    </button>
                </div>
            </div>

            {/* Navigation Tabs */}
            <div className="bs-tabs-nav">
                <button
                    type="button"
                    className={`bs-tab-btn ${activeTab === 'general' ? 'bs-active' : ''}`}
                    onClick={() => setActiveTab('general')}
                >
                    📁 General Info
                </button>
                <button
                    type="button"
                    className={`bs-tab-btn ${activeTab === 'integrations' ? 'bs-active' : ''}`}
                    onClick={() => setActiveTab('integrations')}
                >
                    🔌 Integrations
                </button>
            </div>

            {/* Tab: General Info */}
            {activeTab === 'general' && (
                <div className="bs-tab-panel">
                    {/* Basic Info Card */}
                    <div className="bs-card">
                        <div className="bs-card-title">📁 Basic Information</div>
                        <div className="bs-grid-2">
                            <div className="bs-form-group">
                                <label>Business Name</label>
                                <input
                                    type="text"
                                    name="business_name"
                                    className="bs-input"
                                    value={formData.business_name}
                                    onChange={handleInputChange}
                                    placeholder="Gourmet Grill"
                                />
                            </div>
                            <div className="bs-form-group">
                                <label>Menu URL</label>
                                <input
                                    type="url"
                                    name="menu_url"
                                    className="bs-input"
                                    value={formData.menu_url}
                                    onChange={handleInputChange}
                                    placeholder="https://example.com/menu"
                                />
                            </div>
                            <div className="bs-form-group">
                                <label>Ad Creative URL</label>
                                <input
                                    type="url"
                                    name="ad_creative"
                                    className="bs-input"
                                    value={formData.ad_creative}
                                    onChange={handleInputChange}
                                    placeholder="https://example.com/ad.png"
                                />
                            </div>
                            <div className="bs-grid-2" style={{ gap: '1rem', padding: 0 }}>
                                <div className="bs-form-group">
                                    <label>Opening Time</label>
                                    <input
                                        type="time"
                                        name="opening_hours"
                                        className="bs-input"
                                        value={formData.opening_hours}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="bs-form-group">
                                    <label>Closing Time</label>
                                    <input
                                        type="time"
                                        name="closing_hours"
                                        className="bs-input"
                                        value={formData.closing_hours}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Reservation Settings Card */}
                    <div className="bs-card">
                        <div className="bs-card-title">📅 Reservation Settings</div>
                        <div className="bs-integration-item" style={{ display: 'flex', flexDirection: 'column', marginBottom: 0 }}>
                            <div className="bs-integration-header">
                                <div className="bs-integration-platform" style={{ fontSize: '1rem' }}>
                                    Auto Approve Reservations
                                </div>
                                <label className="bs-toggle-switch">
                                    <input
                                        type="checkbox"
                                        checked={!!formData.auto_approve_reservations}
                                        onChange={(e) => setFormData(prev => ({ ...prev, auto_approve_reservations: e.target.checked }))}
                                    />
                                    <span className="bs-slider"></span>
                                </label>
                            </div>
                            <p style={{ fontSize: '0.825rem', color: 'var(--bs-gray-text)', margin: '0.25rem 0 0 0' }}>
                                Automatically approve incoming reservation requests.
                            </p>
                        </div>
                    </div>

                    {/* Food Platforms Card */}
                    <div className="bs-card">
                        <div className="bs-card-title">🚴 Food Delivery Platforms</div>
                        <div className="bs-grid-2">
                            <div className="bs-form-group">
                                <label>Swiggy Restaurant ID</label>
                                <input
                                    type="text"
                                    name="swiggy_res_id"
                                    className="bs-input"
                                    value={formData.swiggy_res_id}
                                    onChange={handleInputChange}
                                    placeholder="838972"
                                />
                            </div>
                            <div className="bs-form-group">
                                <label>Swiggy Access Token</label>
                                <input
                                    type="password"
                                    name="swiggy_access_token"
                                    className="bs-input"
                                    value={formData.swiggy_access_token}
                                    onChange={handleInputChange}
                                    placeholder="••••••••••••••••••••••••••••••••"
                                />
                            </div>
                            <div className="bs-form-group">
                                <label>EasyDiner Restaurant ID</label>
                                <input
                                    type="text"
                                    name="easydiner_res_id"
                                    className="bs-input"
                                    value={formData.easydiner_res_id}
                                    onChange={handleInputChange}
                                    placeholder="693693"
                                />
                            </div>
                            <div className="bs-form-group">
                                <label>EasyDiner Integration Token</label>
                                <input
                                    type="password"
                                    name="easydiner_access_token"
                                    className="bs-input"
                                    value={formData.easydiner_access_token}
                                    onChange={handleInputChange}
                                    placeholder="••••••••••••••••••••••••••••••••"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Alert Manager Card */}
                    <div className="bs-card">
                        <div className="bs-card-title">🔔 Alert Manager</div>
                        <p style={{ fontSize: '0.9rem', color: 'var(--bs-gray-text)', marginBottom: '1.5rem' }}>
                            Configure notification phone numbers that will receive alerts for negative feedback, reservations, and critical events.
                        </p>
                        <div className="bs-form-group">
                            <label>Add Notification Phone Number</label>
                            <form onSubmit={handleAddPhoneNumber} className="bs-dynamic-item" style={{ gap: '0.5rem', maxWidth: '500px' }}>
                                <input
                                    type="tel"
                                    className="bs-input bs-dynamic-input"
                                    value={tempPhoneNumber}
                                    onChange={(e) => setTempPhoneNumber(e.target.value)}
                                    placeholder="e.g. 8104600736"
                                />
                                <button type="submit" className="bs-btn bs-btn-primary" style={{ whiteSpace: 'nowrap' }}>
                                    ➕ Add Number
                                </button>
                            </form>
                            <span className="bs-hint" style={{ marginTop: '0.2rem' }}>Press Enter or click Add to append to alert recipients.</span>

                            <div className="bs-tag-container" style={{ marginTop: '1rem' }}>
                                {formData.manager_phone_numbers.map((num) => (
                                    <span key={num} className="bs-tag">
                                        📞 {num}
                                        <button
                                            type="button"
                                            className="bs-tag-remove"
                                            onClick={() => handleRemovePhoneNumber(num)}
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                                {formData.manager_phone_numbers.length === 0 && (
                                    <span style={{ fontSize: '0.8rem', color: '#9ca3af', fontStyle: 'italic', margin: 'auto' }}>
                                        No notification numbers registered.
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Tab: Integrations */}
            {activeTab === 'integrations' && (
                <div className="bs-tab-panel">
                    {/* Meta Channels Panel */}
                    <div className="bs-card">
                        <div className="bs-card-title">💬 Meta Channels (Instagram & WhatsApp)</div>

                        {/* WhatsApp Integration */}
                        <div className="bs-integration-item">
                            <div className="bs-integration-header">
                                <div className="bs-integration-platform" style={{ display: 'flex', alignItems: 'center' }}>
                                    <WhatsAppIcon /> WhatsApp Business API
                                </div>
                                <span className={`bs-badge ${isWhatsappConnected ? 'bs-badge-success' : 'bs-badge-danger'}`}>
                                    {isWhatsappConnected ? 'Connected' : 'Disconnected'}
                                </span>
                            </div>

                            {isWhatsappConnected ? (
                                <>
                                    <div className="bs-connection-details">
                                        <div className="bs-detail-pair">
                                            <span className="bs-detail-label">Phone Number ID</span>
                                            <span className="bs-detail-value">{formData.brand?.whatsapp_phone_number_id || formData.whatsapp_phone_number_id}</span>
                                        </div>
                                        <div className="bs-detail-pair">
                                            <span className="bs-detail-label">Phone Number</span>
                                            <span className="bs-detail-value">+{formData.brand?.whatsapp_phone_number}</span>
                                        </div>
                                        <div className="bs-detail-pair">
                                            <span className="bs-detail-label">WABA ID</span>
                                            <span className="bs-detail-value">{formData.brand?.whatsapp_business_account_id || '-'}</span>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        className="bs-btn bs-btn-outline"
                                        onClick={() => handleConnect('whatsapp')}
                                    >
                                        🔄 Reconnect WhatsApp Account
                                    </button>
                                </>
                            ) : (
                                <>
                                    <p style={{ fontSize: '0.9rem', color: 'var(--bs-gray-text)', marginBottom: '1.25rem' }}>
                                        Send automated booking confirmations, queue updates, and customer alerts.
                                    </p>
                                    <button
                                        type="button"
                                        className="bs-btn bs-btn-success"
                                        onClick={() => handleConnect('whatsapp')}
                                    >
                                        🔌 Connect WhatsApp Account
                                    </button>
                                </>
                            )}
                            <div style={{ marginTop: '0.85rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <input
                                    type="checkbox"
                                    id="enable-whatsapp-coexistence"
                                    checked={enableWhatsappCoexistence}
                                    onChange={(e) => setEnableWhatsappCoexistence(e.target.checked)}
                                    style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                                />
                                <label htmlFor="enable-whatsapp-coexistence" style={{ fontSize: '0.825rem', color: 'var(--bs-dark-text)', cursor: 'pointer', margin: 0 }}>
                                    Enable WhatsApp Co-existence (Keep WhatsApp Business App on phone)
                                </label>
                            </div>
                        </div>

                        {/* Instagram Integration */}
                        <div className="bs-integration-item" style={{ marginBottom: 0 }}>
                            <div className="bs-integration-header">
                                <div className="bs-integration-platform" style={{ display: 'flex', alignItems: 'center' }}>
                                    <InstagramIcon /> Instagram Professional
                                </div>
                                <span className={`bs-badge ${isInstagramConnected ? 'bs-badge-success' : 'bs-badge-danger'}`}>
                                    {isInstagramConnected ? 'Connected' : 'Disconnected'}
                                </span>
                            </div>

                            {isInstagramConnected ? (
                                <>
                                    <div className="bs-connection-details">
                                        <div className="bs-detail-pair">
                                            <span className="bs-detail-label">Instagram Username</span>
                                            <span className="bs-detail-value">@{formData.instagram?.username}</span>
                                        </div>
                                        <div className="bs-detail-pair">
                                            <span className="bs-detail-label">Instagram Business ID</span>
                                            <span className="bs-detail-value">{formData.instagram?.instagram_business_account_id}</span>
                                        </div>
                                        <div className="bs-detail-pair">
                                            <span className="bs-detail-label">Connected FB Page ID</span>
                                            <span className="bs-detail-value">{formData.instagram?.facebook_page_id || '-'}</span>
                                        </div>
                                        <div className="bs-detail-pair">
                                            <span className="bs-detail-label">Connected At</span>
                                            <span className="bs-detail-value">
                                                {formData.instagram?.connected_at ? new Date(formData.instagram.connected_at).toLocaleString() : '-'}
                                            </span>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        className="bs-btn bs-btn-outline"
                                        onClick={() => handleConnect('instagram')}
                                    >
                                        🔄 Reconnect Instagram Account
                                    </button>
                                </>
                            ) : (
                                <>
                                    <p style={{ fontSize: '0.9rem', color: 'var(--bs-gray-text)', marginBottom: '1.25rem' }}>
                                        Connect to sync posts automatically to Google.
                                    </p>
                                    <button
                                        type="button"
                                        className="bs-btn bs-btn-primary"
                                        onClick={() => handleConnect('instagram')}
                                    >
                                        🔌 Connect Instagram Account
                                    </button>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Google My Business (GBP) Panel */}
                    <div className="bs-card">
                        <div className="bs-card-title" style={{ display: 'flex', alignItems: 'center' }}>
                            <GoogleGIcon /> Google Business Profile (GBP)
                        </div>

                        {/* GBP Account Connection Header */}
                        <div className="bs-integration-item" style={{ marginBottom: '1.5rem', background: '#f8fafc', padding: '1.25rem', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                            <div className="bs-integration-header" style={{ marginBottom: '0.75rem' }}>
                                <div className="bs-integration-platform" style={{ fontSize: '1rem', display: 'flex', alignItems: 'center' }}>
                                    <GoogleGIcon /> Account Connection
                                </div>
                                <span className={`bs-badge ${formData.gbp?.auth_override?.connected_email || formData.gbp?.location_id ? 'bs-badge-success' : 'bs-badge-danger'}`}>
                                    {formData.gbp?.auth_override?.connected_email || formData.gbp?.location_id ? 'Connected' : 'Disconnected'}
                                </span>
                            </div>

                            {formData.gbp?.auth_override?.connected_email || formData.gbp?.location_id ? (
                                <>
                                    <div className="bs-connection-details">
                                        {formData.gbp?.auth_override?.connected_email && (
                                            <div className="bs-detail-pair">
                                                <span className="bs-detail-label">Connected Account</span>
                                                <span className="bs-detail-value">{formData.gbp.auth_override.connected_email}</span>
                                            </div>
                                        )}
                                        <div className="bs-detail-pair">
                                            <span className="bs-detail-label">Mapped Location</span>
                                            <span
                                                className="bs-detail-value"
                                                title={formData.gbp?.location_name || formData.gbp?.location_id || '-'}
                                                style={{
                                                    fontWeight: 600,
                                                    maxWidth: '220px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    display: 'inline-block',
                                                    cursor: 'help'
                                                }}
                                            >
                                                {formData.gbp?.location_name || formData.gbp?.location_id || '-'}
                                            </span>
                                        </div>
                                        <div className="bs-detail-pair">
                                            <span className="bs-detail-label">Location ID</span>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                {showEditLocationId ? (
                                                    <input
                                                        type="text"
                                                        className="bs-input"
                                                        style={{ padding: '4px 8px', fontSize: '0.85rem', width: '220px' }}
                                                        value={formData.gbp?.location_id || ''}
                                                        onChange={(e) => handleGbpChange('location_id', e.target.value)}
                                                        placeholder="Enter Location ID"
                                                    />
                                                ) : (
                                                    <span className="bs-detail-value" style={{ fontFamily: 'monospace' }}>
                                                        {formData.gbp?.location_id || '-'}
                                                    </span>
                                                )}
                                                <button
                                                    type="button"
                                                    style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.95rem' }}
                                                    title="Edit Location ID manually"
                                                    onClick={() => setShowEditLocationId(prev => !prev)}
                                                >
                                                    ✏️
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ marginTop: '1rem', display: 'flex', gap: '10px', alignItems: 'center' }}>
                                        <button
                                            type="button"
                                            className="bs-btn bs-btn-outline"
                                            onClick={handleConnectGbp}
                                        >
                                            🔄 Re-authorize & Map Google Locations
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <p style={{ fontSize: '0.9rem', color: 'var(--bs-gray-text)', marginBottom: '1.25rem' }}>
                                        Authorize Google to link and manage your business locations.
                                    </p>
                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                                        <button
                                            type="button"
                                            className="bs-btn bs-btn-primary"
                                            onClick={handleConnectGbp}
                                        >
                                            🔌 Connect & Map Locations
                                        </button>
                                        <button
                                            type="button"
                                            className="bs-btn bs-btn-outline"
                                            onClick={() => setShowEditLocationId(prev => !prev)}
                                            title="Manually enter Location ID"
                                        >
                                            ✏️ Manual Location ID
                                        </button>
                                    </div>
                                    {showEditLocationId && (
                                        <div className="bs-form-group" style={{ marginTop: '1rem' }}>
                                            <label>Location ID / Place ID</label>
                                            <input
                                                type="text"
                                                className="bs-input"
                                                value={formData.gbp?.location_id || ''}
                                                onChange={(e) => handleGbpChange('location_id', e.target.value)}
                                                placeholder="e.g. 16184756158839764569"
                                            />
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                        {/* GBP Features Section */}
                        <div style={{ paddingTop: '0.5rem' }}>
                            <div className="bs-grid-2">
                                {/* Option 1: Auto-Manage Customer Reviews */}
                                <div className="bs-integration-item" style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div className="bs-integration-header">
                                        <div className="bs-integration-platform" style={{ fontSize: '1rem' }}>
                                            ⭐️ Auto Manage Reviews
                                        </div>
                                        <label className="bs-toggle-switch">
                                            <input
                                                type="checkbox"
                                                checked={!!formData.gbp?.review_overrides?.is_enabled}
                                                disabled={!formData.gbp?.location_id}
                                                onChange={(e) => handleGbpReviewOverrideChange('is_enabled', e.target.checked)}
                                            />
                                            <span className="bs-slider"></span>
                                        </label>
                                    </div>
                                    <p style={{ fontSize: '0.825rem', color: 'var(--bs-gray-text)', margin: '0 0 1rem 0' }}>
                                        Reply to Google reviews automatically using AI or custom templates.
                                    </p>

                                    {!formData.gbp?.location_id && (
                                        <div style={{
                                            padding: '8px 12px',
                                            background: '#fffbe6',
                                            border: '1px solid #ffe58f',
                                            borderRadius: '6px',
                                            fontSize: '0.8rem',
                                            color: '#d48806',
                                            marginBottom: '1rem'
                                        }}>
                                            ⚠️ Requires mapped Google Location ID
                                        </div>
                                    )}

                                    {/* Sub-collapsible configuration for Review management */}
                                    <div className={`bs-collapsible ${formData.gbp?.review_overrides?.is_enabled ? 'bs-open' : ''}`}>
                                        <div style={{ borderTop: '1px solid var(--bs-border-color)', paddingTop: '1rem', marginTop: '0.5rem' }}>
                                            <div className="bs-form-group">
                                                <label>Negative Star Threshold</label>
                                                <select
                                                    className="bs-select"
                                                    value={formData.gbp?.review_overrides?.negative_star_threshold}
                                                    onChange={(e) => handleGbpReviewOverrideChange('negative_star_threshold', parseInt(e.target.value))}
                                                >
                                                    <option value={1}>1 Star and below (Negative)</option>
                                                    <option value={2}>2 Stars and below (Negative)</option>
                                                    <option value={3}>3 Stars and below (Negative)</option>
                                                    <option value={4}>4 Stars and below (Negative)</option>
                                                </select>
                                                <span className="bs-hint" style={{ marginTop: '0.2rem' }}>Reviews below or equal to this rating trigger negative replies.</span>
                                            </div>

                                            <div className="bs-form-group">
                                                <label>Review Reply Greeting / Header</label>
                                                <textarea
                                                    className="bs-textarea"
                                                    rows={2}
                                                    style={{ minHeight: '60px' }}
                                                    placeholder="e.g. Hi (Optional)"
                                                    value={formData.gbp?.review_overrides?.header ?? ''}
                                                    onChange={(e) => handleGbpReviewOverrideChange('header', e.target.value ? e.target.value : null)}
                                                />
                                                <span className="bs-hint" style={{ marginTop: '0.2rem' }}>Header text prepended to review replies.</span>
                                            </div>

                                            <div className="bs-form-group">
                                                <label>Review Reply Sign-off / Footer</label>
                                                <textarea
                                                    className="bs-textarea"
                                                    rows={2}
                                                    style={{ minHeight: '60px' }}
                                                    placeholder={'e.g. Regards, \n Team ABC'}
                                                    value={formData.gbp?.review_overrides?.footer ?? ''}
                                                    onChange={(e) => handleGbpReviewOverrideChange('footer', e.target.value ? e.target.value : null)}
                                                />
                                                <span className="bs-hint" style={{ marginTop: '0.2rem' }}>Footer text appended to review replies (supports multi-line text).</span>
                                            </div>

                                            {/* Positive Config */}
                                            <div style={{ marginBottom: '1.25rem', padding: '0.85rem', backgroundColor: '#f9fafb', borderRadius: '8px' }}>
                                                <div style={{ fontWeight: 700, fontSize: '0.85rem', marginBottom: '0.5rem', color: 'var(--bs-success)' }}>
                                                    👍 Positive Reviews Config
                                                </div>
                                                <div className="bs-form-group">
                                                    <label>Reply Mode</label>
                                                    <select
                                                        className="bs-select"
                                                        value={formData.gbp?.review_overrides?.positive_config?.mode || 'AUTO_AI'}
                                                        onChange={(e) => handleGbpConfigModeChange('positive_config', e.target.value)}
                                                    >
                                                        <option value="AUTO_AI">Auto AI (Generative response)</option>
                                                        <option value="AUTO_FIXED">Fixed Template (Rotate template list)</option>
                                                    </select>
                                                </div>

                                                {/* Positive AI Prompt */}
                                                <div className={`bs-collapsible ${formData.gbp?.review_overrides?.positive_config?.mode === 'AUTO_AI' ? 'bs-open' : ''}`}>
                                                    <div className="bs-form-group">
                                                        <label>AI Prompt</label>
                                                        <textarea
                                                            className="bs-textarea"
                                                            value={formData.gbp?.review_overrides?.positive_config?.ai_prompt || ''}
                                                            onChange={(e) => handleGbpConfigPromptChange('positive_config', e.target.value)}
                                                            placeholder="You are the hospitality AI. Thank the customer warmly..."
                                                        />
                                                    </div>
                                                </div>

                                                {/* Positive Fixed Templates */}
                                                <div className={`bs-collapsible ${formData.gbp?.review_overrides?.positive_config?.mode === 'AUTO_FIXED' ? 'bs-open' : ''}`}>
                                                    <div className="bs-form-group">
                                                        <label style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            Fixed Templates
                                                            <button
                                                                type="button"
                                                                className="bs-btn bs-btn-outline"
                                                                style={{ padding: '0.2rem 0.5rem', fontSize: '0.75rem' }}
                                                                onClick={() => handleAddTemplate('positive_config')}
                                                            >
                                                                ➕ Add Template
                                                            </button>
                                                        </label>
                                                        <div className="bs-dynamic-list">
                                                            {(formData.gbp?.review_overrides?.positive_config?.templates || []).map((tpl, index) => (
                                                                <div key={index} className="bs-dynamic-item">
                                                                    <input
                                                                        type="text"
                                                                        className="bs-input bs-dynamic-input"
                                                                        value={tpl}
                                                                        onChange={(e) => handleTemplateValueChange('positive_config', index, e.target.value)}
                                                                        placeholder={`Template #${index + 1}`}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="bs-btn bs-btn-danger-outline"
                                                                        style={{ padding: '0.5rem' }}
                                                                        onClick={() => handleRemoveTemplate('positive_config', index)}
                                                                    >
                                                                        🗑️
                                                                    </button>
                                                                </div>
                                                            ))}
                                                            {(formData.gbp?.review_overrides?.positive_config?.templates || []).length === 0 && (
                                                                <span style={{ fontSize: '0.8rem', color: '#9ca3af', fontStyle: 'italic' }}>No templates added yet.</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Negative Config */}
                                            <div style={{ padding: '0.85rem', backgroundColor: '#f9fafb', borderRadius: '8px' }}>
                                                <div style={{ fontWeight: 700, fontSize: '0.85rem', marginBottom: '0.5rem', color: 'var(--bs-danger)' }}>
                                                    👎 Negative Reviews Config
                                                </div>
                                                <div className="bs-form-group">
                                                    <label>Reply Mode</label>
                                                    <select
                                                        className="bs-select"
                                                        value={formData.gbp?.review_overrides?.negative_config?.mode || 'AUTO_AI'}
                                                        onChange={(e) => handleGbpConfigModeChange('negative_config', e.target.value)}
                                                    >
                                                        <option value="AUTO_AI">Auto AI (Generative response)</option>
                                                        <option value="AUTO_FIXED">Fixed Template (Rotate template list)</option>
                                                    </select>
                                                </div>

                                                {/* Negative AI Prompt */}
                                                <div className={`bs-collapsible ${formData.gbp?.review_overrides?.negative_config?.mode === 'AUTO_AI' ? 'bs-open' : ''}`}>
                                                    <div className="bs-form-group">
                                                        <label>AI Prompt</label>
                                                        <textarea
                                                            className="bs-textarea"
                                                            value={formData.gbp?.review_overrides?.negative_config?.ai_prompt || ''}
                                                            onChange={(e) => handleGbpConfigPromptChange('negative_config', e.target.value)}
                                                            placeholder="Apologize sincerely and ask them to WhatsApp our manager..."
                                                        />
                                                    </div>
                                                </div>

                                                {/* Negative Fixed Templates */}
                                                <div className={`bs-collapsible ${formData.gbp?.review_overrides?.negative_config?.mode === 'AUTO_FIXED' ? 'bs-open' : ''}`}>
                                                    <div className="bs-form-group">
                                                        <label style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            Fixed Templates
                                                            <button
                                                                type="button"
                                                                className="bs-btn bs-btn-outline"
                                                                style={{ padding: '0.2rem 0.5rem', fontSize: '0.75rem' }}
                                                                onClick={() => handleAddTemplate('negative_config')}
                                                            >
                                                                ➕ Add Template
                                                            </button>
                                                        </label>
                                                        <div className="bs-dynamic-list">
                                                            {(formData.gbp?.review_overrides?.negative_config?.templates || []).map((tpl, index) => (
                                                                <div key={index} className="bs-dynamic-item">
                                                                    <input
                                                                        type="text"
                                                                        className="bs-input bs-dynamic-input"
                                                                        value={tpl}
                                                                        onChange={(e) => handleTemplateValueChange('negative_config', index, e.target.value)}
                                                                        placeholder={`Template #${index + 1}`}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="bs-btn bs-btn-danger-outline"
                                                                        style={{ padding: '0.5rem' }}
                                                                        onClick={() => handleRemoveTemplate('negative_config', index)}
                                                                    >
                                                                        🗑️
                                                                    </button>
                                                                </div>
                                                            ))}
                                                            {(formData.gbp?.review_overrides?.negative_config?.templates || []).length === 0 && (
                                                                <span style={{ fontSize: '0.8rem', color: '#9ca3af', fontStyle: 'italic' }}>No templates added yet.</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                {/* Option 2: Auto-Post Instagram Posts to Google My Business */}
                                <div className="bs-integration-item" style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div className="bs-integration-header">
                                        <div className="bs-integration-platform" style={{ fontSize: '1rem', display: 'flex', alignItems: 'center' }}>
                                            <InstagramIcon /> Auto-Post to Google
                                        </div>
                                        <label className="bs-toggle-switch">
                                            <input
                                                type="checkbox"
                                                checked={!!formData.insta_to_gmb_active}
                                                disabled={!isInstagramConnected || !formData.gbp?.location_id}
                                                onChange={(e) => handleInstaToGmbChange('insta_to_gmb_active', e.target.checked)}
                                            />
                                            <span className="bs-slider"></span>
                                        </label>
                                    </div>
                                    <p style={{ fontSize: '0.825rem', color: 'var(--bs-gray-text)', margin: '0 0 1rem 0' }}>
                                        Automatically publish your Instagram feed directly to Google Updates.
                                    </p>

                                    {(!isInstagramConnected || !formData.gbp?.location_id) && (
                                        <div style={{
                                            padding: '8px 12px',
                                            background: '#fffbe6',
                                            border: '1px solid #ffe58f',
                                            borderRadius: '6px',
                                            fontSize: '0.8rem',
                                            color: '#d48806'
                                        }}>
                                            ⚠️ Requires Instagram connection & mapped Google Location ID
                                        </div>
                                    )}

                                    {/* Collapsible Instagram Config details */}
                                    <div className={`bs-collapsible ${isInstagramConnected && formData.insta_to_gmb_active ? 'bs-open' : ''}`}>
                                        <div style={{ borderTop: '1px solid var(--bs-border-color)', paddingTop: '1rem', marginTop: '0.5rem' }}>
                                            <div className="bs-form-group">
                                                <label>CTA Button Type</label>
                                                <select
                                                    className="bs-select"
                                                    value={formData.insta_to_gmb_cta_type || 'LEARN_MORE'}
                                                    onChange={(e) => handleInstaToGmbChange('insta_to_gmb_cta_type', e.target.value)}
                                                >
                                                    <option value="LEARN_MORE">Learn More</option>
                                                    <option value="BOOK">Book Now</option>
                                                    <option value="CALL_NOW">Call Now</option>
                                                    <option value="ORDER_NOW">Order Now</option>
                                                    <option value="SHOP_NOW">Shop Now</option>
                                                    <option value="SIGN_UP">Sign Up</option>
                                                </select>
                                            </div>

                                            <div className="bs-form-group">
                                                <label>CTA Target URL</label>
                                                <input
                                                    type="url"
                                                    className="bs-input"
                                                    value={formData.insta_to_gmb_cta_url || ''}
                                                    onChange={(e) => handleInstaToGmbChange('insta_to_gmb_cta_url', e.target.value)}
                                                    placeholder="https://app.waitwhiz.in/"
                                                />
                                            </div>

                                            <div className="bs-form-group">
                                                <label>Caption Rewrite AI Prompt</label>
                                                <textarea
                                                    className="bs-textarea"
                                                    value={formData.insta_to_gmb_ai_prompt || ''}
                                                    onChange={(e) => handleInstaToGmbChange('insta_to_gmb_ai_prompt', e.target.value)}
                                                    placeholder="Rewrite the caption for Google Maps updates, max 300 chars..."
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Floating Unsaved Changes Warning Banner */}
            {isDirty() && (
                <div className="bs-floating-save-bar">
                    <div className="bs-save-msg">
                        <span>⚠️ You have unsaved changes in this form</span>
                    </div>
                    <div className="bs-save-actions">
                        <button
                            type="button"
                            className="bs-btn bs-btn-outline"
                            onClick={handleDiscard}
                            disabled={saving}
                        >
                            Discard
                        </button>
                        <button
                            type="button"
                            className="bs-btn bs-btn-success"
                            onClick={handleSave}
                            disabled={saving}
                        >
                            {saving ? 'Saving...' : 'Save Changes'}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BusinessSettings;
